<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap login-otp-left-wrap">
            <div class="back-icon text-start">
              <router-link to="/verify-identity" class="ms-0 ps-0">Back</router-link>
            </div>
            <div class="left-login">
              <div class="rep-icon-login">
                <img src="../../assets/images/dashboard-rep.svg" alt="image-fluid" />
              </div>
            </div>
            <h4 class="login-title mb-1">Verify OTP</h4>
            <div class="auth-form pt-3 pb-3">
              <div class="email-change-wrap">
                <div>{{ repEmail }}</div>
                <div class="login-highlight" @click="routeToLogin">Change</div>
              </div>
              <form @submit.prevent>
                <div class="mt-3">
                  <div class="d-flex justify-content-between">
                    <label class="opt-label mt-0">Enter OTP<span class="required-label">*</span></label>
                  </div>
                  <div class="otp-input-wrapper d-flex">
                    <input
                      v-for="(_, idx) in 6"
                      :key="idx"
                      ref="inputs"
                      v-model="digits[idx]"
                      type="tel"
                      maxlength="1"
                      autocomplete="one-time-code"
                      class="otp-input"
                      :class="{ 'error-border': otpErrorFlag }"
                      :disabled="isLockedOut"
                      @input="handleInput(idx, $event)"
                      @keydown.delete="handleDelete(idx, $event)"
                      @paste.prevent="handlePaste"
                      @focus="clearError"
                      :aria-label="`OTP digit ${idx + 1}`"
                    >
                  </div>
                  <div v-if="otpErrorFlag && !isLockedOut" class="valid-error mt-2">
                    {{ errorMsg }}
                  </div>
                </div>
              </form>
              <button
                @click="verifyToken"
                :disabled="formLoader || !isOtpComplete || isLockedOut"
                class="submit-btn mt-3 next-btn"
                type="button"
              >
                <b-spinner v-if="formLoader" small />
                Verify OTP
              </button>
              <login-otp
                v-if="!isLockedOut"
                @sendOTP="sendOTP"
                :expirySecond="60"
                :setSpinnerLoader="otpLoader"
              />
              <lockout-timer
                v-if="isLockedOut"
                :lockout-seconds="lockoutSeconds"
                @lockout-expired="handleLockoutExpired"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <login-in-carsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import helper from "@/resource/Helper";
import Logincarsoule from "./Logincarsoule";
import NewLoginOTP from "../../components/ui/NewLoginOTP";
import LockoutTimer from "../../components/ui/OtpLockoutTimer.vue";

export default {
  name: "OtpVerify",
  components: {
    'login-in-carsoule': Logincarsoule,
    'login-otp': NewLoginOTP,
    'lockout-timer': LockoutTimer
  },
  data() {
    return {
      digits: Array(6).fill(''),
      otpLoader: false,
      formLoader: false,
      otpErrorFlag: false,
      errorMsg: '',
      isLockedOut: false,
      lockoutSeconds: 0,
      repEmail:"",
    };
  },
  computed: {
    ...mapGetters({
      verifiedIdentitySelectedInfo: 'verifiedIdentitySelectedInfo',
      // repEmail: 'repEmail',
      deviceId: 'deviceId'
    }),
    isOtpComplete() {
      return this.digits.every(d => d.length === 1 && /\d/.test(d));
    },
    otp() {
      return this.digits.join('');
    }
  },
  mounted() {
    if (this.$store.getters.loginOtpSource === 'login') {
      this.repEmail = this.$store.getters.repEmail;
    }
    if (this.$store.getters.loginOtpSource === 'forgot') {
      this.repEmail= this.verifiedIdentitySelectedInfo.email;
    }
    this.focusFirstInput();
  },
  methods: {
    routeToLogin() {
      this.$router.push('/verify-identity');
    },
    handleInput(idx, event) {
      if (this.isLockedOut) return;
      const value = event.target.value.replace(/\D/g, '');
      this.digits.splice(idx, 1, value.slice(-1));

      if (value && idx < 5) {
        this.$refs.inputs[idx + 1].focus();
      }

      if (this.isOtpComplete) {
        this.verifyToken();
      }
    },
    handleDelete(idx) {
      if (this.isLockedOut) return;
      if (idx > 0 && !this.digits[idx]) {
        this.$refs.inputs[idx - 1].focus();
      }
    },
    handlePaste(event) {
      if (this.isLockedOut) return;
      const pasteData = (event.clipboardData || window.clipboardData)
        .getData('text/plain')
        .replace(/\D/g, '')
        .slice(0, 6)
        .split('');

      this.digits = [...pasteData, ...Array(6 - pasteData.length).fill('')];
      this.focusInput(pasteData.length);

      if (this.isOtpComplete) {
        this.verifyToken();
      }
    },
    focusFirstInput(retry = 5) {
      this.$nextTick(() => {
        const input = this.$refs.inputs?.[0];
        if (input && !this.isLockedOut) {
          input.focus();
        } else if (retry > 0) {
          setTimeout(() => this.focusFirstInput(retry - 1), 50);
        }
      });
    },
    focusInput(idx) {
      if (this.isLockedOut) return;
      this.$nextTick(() => {
        const targetIndex = Math.min(idx, 5);
        this.$refs.inputs[targetIndex]?.focus();
      });
    },
    clearError() {
      if (this.isLockedOut) return;
      this.otpErrorFlag = false;
      this.errorMsg = '';
    },
    parseLockoutDuration(message) {
      const match = message.match(/(\d+)\s*minute[s]?(\s*and\s*(\d+)\s*second[s]?)?|(\d+)\s*second[s]?/);
      if (!match) {
        console.warn('Failed to parse lockout duration:', message);
        return 0;
      }
      const minutes = parseInt(match[1]) || 0;
      const seconds = parseInt(match[3]) || parseInt(match[4]) || 0;
      return minutes * 60 + seconds;
    },
    verifyToken() {
      if (!this.isOtpComplete) {
        this.otpErrorFlag = true;
        this.errorMsg = "Please enter a 6-digit OTP to proceed";
        return;
      }

      this.formLoader = true;
      this.clearError();

      axios.post(this.$endpoint.API_V4_RESET_OTP_VERIFY, null, {
        params: {
          email: this.repEmail,
          device_id: this.deviceId,
          reset_code: this.otp,
        }
      })
      .then((response) => {
        if (response.data.status === "success") {
          this.$store.commit("setOtpCode", this.otp);
          this.$store.commit("setResetToken", response.data.reset_token);
          this.$store.commit("setResetTokenExpiry", response.data.expires_at);
          this.$router.push("/reset-password");
        }
      })
      .catch((error) => {
        const errorResponse = error.response?.data;
        if (errorResponse?.statusCode === 429 || error.response?.status === 429) {
          this.isLockedOut = true;
          this.lockoutSeconds = this.parseLockoutDuration(errorResponse?.message || '');
          this.otpErrorFlag = false;
          this.errorMsg = '';
        } else {
          this.otpErrorFlag = true;
          this.errorMsg = errorResponse?.message || "Something went wrong. Please try again.";
        }
      })
      .finally(() => {
        this.formLoader = false;
      });
    },
    sendOTP() {
      if (this.isLockedOut) return;
      this.otpLoader = true;
      this.$store.dispatch('verifiedIdentitySelectedInfo', this.verifiedIdentitySelectedInfo);
      axios.post(this.$endpoint.API_V4_RESET_OTP_SEND, this.verifiedIdentitySelectedInfo)
        .then((response) => {
          if (response.data.status === "success") {
            this.$router.push('/otp-verify');
            helper.infoMessage(this, response.data.status, response.data.message);
            this.digits = Array(6).fill('');
            this.focusFirstInput();
          }
        })
        .catch((error) => {
          const errorResponse = error.response?.data;
          if (errorResponse?.status === "error") {
            if (errorResponse.statusCode === 429 || error.response?.status === 429) {
              this.isLockedOut = true;
              this.lockoutSeconds = this.parseLockoutDuration(errorResponse.message);
              this.otpErrorFlag = false;
              this.errorMsg = '';
            } else {
              this.otpErrorFlag = true;
              this.errorMsg = errorResponse.message;
            }
            helper.infoMessage(this, errorResponse.status, errorResponse.message);
          }
        })
        .finally(() => {
          this.otpLoader = false;
        });
    },
    handleLockoutExpired() {
      this.isLockedOut = false;
      this.lockoutSeconds = 0;
      this.otpErrorFlag = false;
      this.errorMsg = '';
      this.digits = Array(6).fill('');
      this.focusFirstInput();
    },
  },
};
</script>

<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
.otp-input-wrapper {
  gap: 25px;
  margin-bottom: 10px;
}
.auth-form .otp-input-wrapper input.otp-input {
  height: 53px;
  border: 1px solid #bbb;
  border-radius: 8px;
  text-align: center;
  font-size: 1.2rem;
  transition: all 0.2s ease;
  box-shadow: 0;
}
.otp-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  outline: none;
}
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100px;
}
.new-login-wrapper .highlight_otp {
  border: 2px solid #dc3545 !important;
}
.new-login-wrapper .valid-error {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
.resend-timer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}
.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.error-border {
  border-color: #dc3545 !important;
}
.login-highlight {
  cursor: pointer;
}
@media(max-width: 1399px){
  .otp-input-wrapper {
    gap: 15px;
  }
}
@media (max-width: 992px) {
    .otp-input-wrapper {
        gap: 5px;
        margin: 0 0 10px 0;
    }
}
</style>